import { FormattedMessage } from 'react-intl';
import styled from '@emotion/styled';
import { colors } from '@anyroad/theme';

interface CashPaymentNoticeProps {
  totalInLocalCurrencyFormatted?: string;
  totalFormatted?: string;
  date?: string;
}

const ContentBox = styled.div`
  color: ${colors.text.secondary};
  margin: 0 -20px;
  background: ${colors.background.light};
  border-bottom: 0;
  padding: 20px;

  .CheckoutNavigationController & {
    padding: 0 20px;
  }
`;

export const CashPaymentNotice = ({
  totalInLocalCurrencyFormatted,
  totalFormatted,
  date,
}: CashPaymentNoticeProps) => (
  <ContentBox className="CheckoutSummary-ContentBox CashPaymentNotice">
    <div className="CheckoutSummary-CashPaymentNotice">
      <p>
        <FormattedMessage
          defaultMessage="Amount due in <strong>cash</strong> when you arrive on <strong>{date}</strong>."
          values={{ date, strong: (chunks) => <strong>{chunks}</strong> }}
        />{' '}
        {totalInLocalCurrencyFormatted !== totalFormatted && (
          <FormattedMessage
            defaultMessage="Please pay in the local currency amount of {amount}."
            values={{ amount: totalInLocalCurrencyFormatted }}
          />
        )}
      </p>
    </div>
  </ContentBox>
);
